import React from 'react'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import SuggestField from '@modules/admin/common/fields/suggestField'
import Consultations from '@services/Consultations'
import InfoPanel from '@modules/admin/common/infoPanel'
import InputField from '@modules/formFields/InputField'

const ProfessionalGroupsForm = ({ initialValues, handleSubmit, onSubmit, submitting, t }) => {
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InfoPanel background="yellow" text={t('disclaimerProfessionalGroup')} iconFont="fa-exclamation-triangle" />
      <Field name="name" component={InputField} placeholder={t('groupName')} label={t('groupName')} />
      <Field name="code" component={InputField} placeholder={t('groupCode')} label={t('groupCode')} />

      <Field
        name="professionals"
        component={SuggestField}
        client={(params) => Consultations.professional.index(params)}
        placeholder={t('assignedProfessionals')}
        label={t('assignedProfessionals')}
      />
      {/*      <Field
        name="company_groups"
        label={t('assignedUserGroups')}
        placeholder={t('assignedUserGroups')}
        component={SuggestField}
        client={(params)=>Consultations.userGroups.index(params)}
      />*/}
      <button type="submit" className="btn btn-primary" disabled={submitting}>
        {t('saveProfessionalGroup')}
      </button>
    </Form>
  )
}
const validate = (values, props) => {
  let errors = {}
  const { t } = props
  if (!values.name) errors.name = t('Campo requerido')
  if (!values.code) errors.code = t('Campo requerido')
  if (!values?.professionals?.length) errors.professionals = t('Campo requerido')
  return errors
}
export const ProfessionalGroupsRedux = reduxForm({
  form: 'professionalGroups',
  validate,
})(ProfessionalGroupsForm)
